export default __webpack_public_path__ + "static/media/horacinis_cafe.0a926cd1.jpg";